import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import {
  UserGroupIcon,
  HomeIcon,
  StarIcon,
  CurrencyDollarIcon,
  IdentificationIcon,
  AnnotationIcon,
  CursorClickIcon,
  DocumentTextIcon,
} from "@heroicons/react/outline";
import SideFooter from "../../components/sidebar/SideFooter";
import SidebarWithHeader from "../../components/Layouts/SidebarWithHaeder";
import AppLogo from "../../components/AppLogo";
import { useAuth } from "../../context/AuthContext";
import CandidateModel from "../../api/models/CandidateModel";
import { GetNewStudentRequest } from "../../api/endpoints/candidate/requests";
import { makeApiRequest } from "../../helpers";
import { ApiResponse } from "../../api/apiResponse";

function CandidateDashboardPage() {
  const [langModal, setLangModal] = useState(false);
  const LocalNavBasePath = "page.candidate.dashboard.nav";
  const authContext = useAuth();
  const { t, i18n } = useTranslation();
  const [requests, setRequests] = useState<any>([]);

  let navigation: any = [
    {
      name: t(`${LocalNavBasePath}.homePage`),
      href: "/candidate/dashboard/home",
      icon: HomeIcon,
      separate: "top",
    },
    {
      name: t(`${LocalNavBasePath}.recitationEvaluation`),
      icon: StarIcon,
      separate: "top",
      children: [
        {
          name: t(`${LocalNavBasePath}.recitationNotes`),
          href: "/candidate/dashboard/recitation-notes",
        },
        {
          name: t(`${LocalNavBasePath}.recitationSkills`),
          href: "/candidate/dashboard/recitation-skills",
        },
      ],
    },

    {
      name: t(`${LocalNavBasePath}.paymentOfSubscriptions`),
      href: "/candidate/dashboard/payment-subscriptions",
      icon: CurrencyDollarIcon,
      separate: "top",
    },
    {
      name: t(`${LocalNavBasePath}.myPersonalData`),
      href: "/candidate/dashboard/personal-data",
      icon: IdentificationIcon,
    },
    {
      name: t(`${LocalNavBasePath}.readingRoomEtiquette`),
      href: "/candidate/dashboard/reading-room-etiquette",
      icon: UserGroupIcon,
      separate: "top",
    },
    {
      name: t(`${LocalNavBasePath}.provideFeedbackAndSuggestions`),
      href:
        i18n.language === "ar"
          ? "https://sanadquran.com/ar/contact-us/"
          : "https://sanadquran.com/contact-us/",
      icon: AnnotationIcon,
      isBrowserLink: true,
    },
  ];
  const user = authContext?.currentUser as CandidateModel;

  const getNewStudents = async () => {
    const response: any = await GetNewStudentRequest();
    setRequests(response.data.result);
  };
  if (user.isUserQualified && requests?.length > 0) {
    navigation.push(
      {
        name: t(`${LocalNavBasePath}.programRegistration`),
        href: "/candidate/dashboard/program-registration",
        icon: CursorClickIcon,
        separate: "top",
      },
      {
        name: t(`${LocalNavBasePath}.requests`),
        icon: DocumentTextIcon,
        separate: "top",
        children: [
          {
            name: t(`${LocalNavBasePath}.scheduleRequests`),
            href: "/candidate/dashboard/unscheduled-reader",
          },
        ],
      }
    );
  } else if (user.isUserQualified && requests?.length === 0) {
    navigation.push(
      {
        name: t(`${LocalNavBasePath}.programRegistration`),
        href: "/candidate/dashboard/program-registration",
        icon: CursorClickIcon,
        separate: "top",
      },
      {
        name: t(`${LocalNavBasePath}.requests`),
        icon: DocumentTextIcon,
        separate: "top",
        children: [
          {
            name: t(`${LocalNavBasePath}.changeAppointment`),
            href: "/candidate/dashboard/appointments-requests",
          },
        ],
      }
    );
  }
  const userImg = authContext?.currentUser?.profile_picture_url;
  useEffect(() => {
    getNewStudents();
  }, []);
  return (
    <div className="">
      <div className="">
        <SidebarWithHeader
          langModal={langModal}
          setLangModal={setLangModal}
          img={userImg}
          navigation={navigation}
          sideHeader={
            <div className="w-full px-2 pt-5 pb-4">
              <AppLogo />
            </div>
          }
          sideFooter={
            <SideFooter langModal={langModal} setLangModal={setLangModal} />
          }
        ></SidebarWithHeader>
      </div>
    </div>
  );
}
export default CandidateDashboardPage;
